import React from 'react';
import uuid4 from 'uuid/v4';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import downArrowIcon from './assets/down-arrow.svg';
import Dropdown from 'components/Dropdown';

import './styles.css';

const HEADER_CONTAINER_CLASS = 'headerContainer';

class ButtonDropdownOption extends React.Component<any> {
  static contextTypes = {
    closeOptions: PropTypes.func
  };

  render() {
    const {className, children, onClick, disabled = false} = this.props;
    return (
      <Button
        white
        className={classNames(className, 'ButtonDropdownOption')}
        disabled={disabled}
        onClick={e => {
          this.context.closeOptions();
          onClick && onClick(e);
        }}>
        {children}
      </Button>
    );
  }
}

// Will look up to 6 levels above for the parent
const getParentWithClass = (element, iteration = 0) => {
  if (iteration <= 6) {
    if (element.classList.contains(HEADER_CONTAINER_CLASS)) {
      return element;
    }
  } else {
    throw new Error('ButtonDropdown header container has not been found.');
  }
  return getParentWithClass(element.parentElement, iteration + 1);
};

const getHeaderContainerElement = event => getParentWithClass(event.target);

const getTargetElementPosition = event => {
  return getHeaderContainerElement(event).getBoundingClientRect();
};

const DefaultButtonDropdownHeader = ({title, shouldPointUp}) => (
  <React.Fragment>
    <div className="header">{title}</div>
    <img
      src={downArrowIcon}
      alt=""
      className={classNames({pointUp: shouldPointUp})}
    />
  </React.Fragment>
);

class ButtonDropdown extends React.Component<any> {
  state = {
    uuid: uuid4(),
    isOpen: false,
    position: {left: 0, top: 0, width: 0, height: 0}
  };

  openOptions = event => {
    this.setState({
      isOpen: true,
      position: getTargetElementPosition(event)
    });
  };

  closeOptions = () => {
    this.setState({isOpen: false});
  };

  // Method returns menu position with a default value
  getMenuPosition = () => {
    return this.props.menuPosition || ButtonDropdown.MENU_POSITION_BOTTOM_RIGHT;
  };

  shouldImagePointUp = () => {
    const menuPosition = this.getMenuPosition();
    return (
      menuPosition === ButtonDropdown.MENU_POSITION_TOP_LEFT ||
      menuPosition === ButtonDropdown.MENU_POSITION_TOP_RIGHT
    );
  };

  dropdownMenuStyle = () => {
    const menuPosition = this.getMenuPosition();
    const {position} = this.state;
    const menuStyle: any = {};

    // Add button height if it should be shown under
    if (
      menuPosition === ButtonDropdown.MENU_POSITION_BOTTOM ||
      menuPosition === ButtonDropdown.MENU_POSITION_BOTTOM_LEFT ||
      menuPosition === ButtonDropdown.MENU_POSITION_BOTTOM_RIGHT
    ) {
      menuStyle.top = position.height;
    }

    // Add button width if it should be shown on the left
    if (
      menuPosition === ButtonDropdown.MENU_POSITION_TOP_LEFT ||
      menuPosition === ButtonDropdown.MENU_POSITION_BOTTOM_LEFT
    ) {
      menuStyle.right = -position.width;
    }

    if (
      menuPosition === ButtonDropdown.MENU_POSITION_TOP ||
      menuPosition === ButtonDropdown.MENU_POSITION_BOTTOM
    ) {
      menuStyle.width = position.width;
    }

    return menuStyle;
  };

  static MENU_POSITION_TOP_LEFT = 'topLeft';
  static MENU_POSITION_TOP_RIGHT = 'topRight';
  static MENU_POSITION_BOTTOM_LEFT = 'bottomLeft';
  static MENU_POSITION_BOTTOM_RIGHT = 'bottomRight';
  static MENU_POSITION_BOTTOM = 'bottom';
  static MENU_POSITION_TOP = 'top';
  static Option = ButtonDropdownOption;
  static childContextTypes = {
    closeOptions: PropTypes.func
  };

  getChildContext() {
    return {closeOptions: this.closeOptions};
  }

  render() {
    const {
      className,
      dropdownClassName,
      children,
      title,
      disabled = false,
      isLoading,
      tooltip,
      small,
      appendToBody = false,
      HeaderComponent = DefaultButtonDropdownHeader
    } = this.props;
    const {isOpen, position} = this.state;
    const shouldPointUp = this.shouldImagePointUp();

    const menuPosition = this.getMenuPosition();
    const menuStyle = this.dropdownMenuStyle();

    return (
      <div
        className={classNames(className, 'ButtonDropdown', {
          disabled,
          isOpen,
          small
        })}
        data-dropdowntrigger={this.state.uuid}
        title={tooltip ? tooltip : undefined}>
        <Button
          className={HEADER_CONTAINER_CLASS}
          onClick={this.openOptions}
          disabled={disabled}
          isLoading={isLoading}>
          <HeaderComponent title={title} shouldPointUp={shouldPointUp} />
        </Button>
        <Dropdown
          isOpen={isOpen}
          position={position}
          onClose={this.closeOptions}
          triggerKey={this.state.uuid}
          appendToBody={appendToBody}
          className={dropdownClassName}>
          <div
            className={classNames('ButtonDropdownOptions', menuPosition)}
            style={menuStyle}>
            {children}
          </div>
        </Dropdown>
      </div>
    );
  }
}

export default ButtonDropdown;
